import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydSwitch from '../../../../commonDesign/SydSwitch'
import FlexRow from '../../../../molecules/FlexRow'

function BoolFieldEditor ({ field, control }) {
  return (
    <Controller
      name={field.id}
      control={control}
      render={({ field: hookField }) => (
        <FlexRow className='align-center justify-center'>
          <SydSwitch
            {...hookField}
            checked={hookField.value || false}
            label={field.label}
          />
          <div>{field.label}</div>
        </FlexRow>
      )}
    />
  )
}

BoolFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string
  }).isRequired,
  control: PropTypes.object.isRequired
}

export default BoolFieldEditor
